/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Dispatch } from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import Input from '@salesforce/design-system-react/components/input';
import InputIcon from '@salesforce/design-system-react/components/icon/input-icon';

import AutocompleteMultiSelectPicker from '../../../../../../Shared/AutocompleteMultiSelectPicker';
import { getHoldIcon } from '../../../../../../../util/utilityFunctions';
import { SearchInventoryFN } from '../AddPartsModal.types';
import styles from './styles.module.scss';

interface SearchBarProps {
  searchInventory: SearchInventoryFN;
  loading: boolean;
  productGroups: any[];
  loadingProductGroups: boolean;
  selectedGroup: any[];
  setSelectedGroup: Dispatch<React.SetStateAction<any[]>>;
}

export default function SearchBar({
  searchInventory,
  loading,
  productGroups = [],
  loadingProductGroups,
  selectedGroup = [],
  setSelectedGroup,
}: SearchBarProps) {
  const holdIconPath = getHoldIcon();

  return (
    <div className={styles.container}>
      <div className="full-width_button-product" id="product-catalog">
        <AutocompleteMultiSelectPicker
          items={productGroups}
          setSelectedItems={(result: any): void => {
            setSelectedGroup(result);
          }}
          disabled={loadingProductGroups}
          selectedItems={selectedGroup}
          placeholder="Select Product Group"
          label=""
          withAddMenuButton={false}
          filterPicker
          name="productGroup"
        />
      </div>
      <div className={`catalog-input ${styles.searchBar}`}>
        <Input
          assistiveText={{ spinner: 'Field data is loading' }}
          iconRight={<InputIcon name="search" category="utility" />}
          onChange={(e, searchItem) => {
            searchInventory(e, searchItem);
          }}
          hasSpinner={loading}
          id="unique-id-4"
          placeholder="Search Part"
          data-testid="parts-search-input"
        />
      </div>
      <div className={styles.statusIconContainer}>
        <div className={styles.statusInnerContainer}>
          <span>
            <Icon
              category="utility"
              name="notification"
              size="x-small"
              className={styles.notificationIcon}
            />
            <p>Expiring in 90 days</p>
          </span>
          <span>
            <Icon category="utility" name="clock" size="x-small" className={styles.clockIcon} />
            <p>30 days</p>
          </span>
          <span>
            <Icon category="utility" name="warning" size="x-small" className={styles.warningIcon} />
            <p>Expired</p>
          </span>
          <span>
            <img src={holdIconPath} className="logo-image" alt="company" />
            <p>On Hold</p>
          </span>
        </div>
      </div>
    </div>
  );
}
